import clsx from 'clsx';
import NextImage, { ImageProps } from 'next/image';

import { ImageJsonLd, ImageJsonLdProps } from 'next-seo';

import { generateBlurDataURL } from '@/utils/image';

import { calculateObjectPosition } from './util/calculateObjectPosition';

import styles from './Image.module.scss';

type ImageServerProps = ImageProps & {
    className?: string;
    focalPoints?: string;
    jsonData?: ImageJsonLdProps;
};

export const ImageBlockServer: React.FC<ImageServerProps> = async ({
    src,
    width = 0,
    height = 0,
    className,
    focalPoints,
    jsonData,
    alt,
    ...props
}) => {
    if (!src) {
        return null;
    }

    const placeholderUrl = `${src}/m/10x10/smart/filters:format(webp)`;
    const blurDataURL = await generateBlurDataURL(placeholderUrl);

    const focalPointsFilter = focalPoints ? `:focal(${focalPoints})` : '';
    const source = `${src}/m/${2 * Number(width)}x${2 * Number(height)}/filters:format(webp)${focalPointsFilter}`;

    const objectPosition = calculateObjectPosition(src.toString(), focalPoints);

    return (
        <>
            {jsonData && (
                <ImageJsonLd
                    useAppDir
                    {...jsonData}
                />
            )}

            <NextImage
                placeholder="blur"
                blurDataURL={blurDataURL}
                className={clsx(styles.imageDefault, className)}
                width={width}
                height={height}
                style={{ objectPosition }}
                src={source}
                alt={alt}
                {...props}
            />
        </>
    );
};
